import { APP_NAME } from "@constants/app.constants";
import BannerListComponent from "@screens/design/banners/banner-list/banner-list.component";
import BannerCreateComponent from "@screens/design/banners/banner-create/banner-create.component";
import BannerEditComponent from "@screens/design/banners/banner-edit/banner-edit.component";

const bannersRoutes = [
  {
    name: `Banners - ${APP_NAME}`,
    path: "/design/banners",
    icon: "layout",
    component: BannerListComponent,
  },
  {
    name: `Create Banner - ${APP_NAME}`,
    path: "/design/banners/create",
    component: BannerCreateComponent,
  },
  {
    name: `Edit Banner - ${APP_NAME}`,
    path: "/design/banners/edit",
    component: BannerEditComponent,
  },
];

export default bannersRoutes;
